<template>
  <admin-payment title="Pagina de Pagamento">
    <div class="row">
      <div v-if="!plan.id">
        <h1>Plano não encontrado</h1>
      </div>
      <div v-if="plan.id">
        <h1>{{plan.name}}</h1>
        <pre>{{plan.description}}</pre>
      </div>
    </div>
  </admin-payment>
</template>

<script>
export default {
  props: ["plan"],
};
</script>
